/* @flow */
import React from "react";

import { Link } from "../common/Link";
import Gettext from "../common/Gettext";
import { Row, Input, SelectColor, SelectWidth } from "../Popup";
import { InfoBlock } from "./ToolsContent";
import { COLORS } from "../Popup/SelectColor";
import { WIDTHS } from "../Popup/SelectWidth";

export const initialState = {
  jaws: {
    period: 13,
    shift: 8,
    color: COLORS[0],
    strokeWidth: WIDTHS[0],
  },
  teeths: {
    period: 8,
    shift: 5,
    color: COLORS[1],
    strokeWidth: WIDTHS[0],
  },
  lips: {
    period: 5,
    shift: 3,
    color: COLORS[2],
    strokeWidth: WIDTHS[0]
  }
};

export const indicatorTitle = <Gettext>Alligator</Gettext>;

export const Info = <InfoBlock>
  <Gettext>
    This indicator contains three Moving Average lines with different periods and a different offset. <Link to="/helpdesk/knowledge_base#kb_i">
      <Gettext>Learn more about the indicator.</Gettext>
    </Link>
  </Gettext>
</InfoBlock>;

type Props = {
  mobile: Boolean,
  indicator: Object,
  activeSelect: String,
  handleClick: Function,
  handleNestedChange: Function
};

const AlligatorPopup = (props: Props) => (
  <React.Fragment>
    <Row
      title={<Gettext>Jaws</Gettext>}
      share={props.mobile === true && 3}
    >
      <Input
        label={<Gettext>Period</Gettext>}
        name="jaws_period"
        value={props.indicator.jaws.period}
        onChange={props.handleNestedChange("jaws", "period")}
        invalid={props.errors && props.errors.jaws_period}
      />
      <Input
        label={<Gettext>Shift</Gettext>}
        name="jaws_shift"
        value={props.indicator.jaws.shift}
        onChange={props.handleNestedChange("jaws", "shift")}
        invalid={props.errors && props.errors.jaws_shift}
      />
      <SelectColor
        label={<Gettext>Colour</Gettext>}
        name="jaws_color"
        value={props.indicator.jaws.color}
        activeSelect={props.activeSelect}
        onClick={props.handleClick}
        onChange={props.handleNestedChange("jaws", "color")}
      />
      <SelectWidth
        label={<Gettext>Width of lines</Gettext>}
        name="jaws_strokeWidth"
        value={props.indicator.jaws.strokeWidth}
        activeSelect={props.activeSelect}
        onClick={props.handleClick}
        onChange={props.handleNestedChange("jaws", "strokeWidth")}
      />
    </Row>

    <Row
      title={<Gettext>Teeth</Gettext>}
      share={props.mobile === true && 3}
    >
      <Input
        label={<Gettext>Period</Gettext>}
        name="teeths_period"
        value={props.indicator.teeths.period}
        onChange={props.handleNestedChange("teeths", "period")}
        invalid={props.errors && props.errors.teeths_period}
      />
      <Input
        label={<Gettext>Shift</Gettext>}
        name="teeths_shift"
        value={props.indicator.teeths.shift}
        onChange={props.handleNestedChange("teeths", "shift")}
        invalid={props.errors && props.errors.teeths_shift}
      />
      <SelectColor
        label={<Gettext>Colour</Gettext>}
        name="teeths_color"
        value={props.indicator.teeths.color}
        activeSelect={props.activeSelect}
        onClick={props.handleClick}
        onChange={props.handleNestedChange("teeths", "color")}
      />
      <SelectWidth
        label={<Gettext>Width of lines</Gettext>}
        name="teeths_strokeWidth"
        value={props.indicator.teeths.strokeWidth}
        activeSelect={props.activeSelect}
        onClick={props.handleClick}
        onChange={props.handleNestedChange("teeths", "strokeWidth")}
      />
    </Row>

    <Row
      title={<Gettext>Lips</Gettext>}
      share={props.mobile === true && 3}
    >
      <Input
        label={<Gettext>Period</Gettext>}
        name="lips_period"
        value={props.indicator.lips.period}
        onChange={props.handleNestedChange("lips", "period")}
        invalid={props.errors && props.errors.lips_period}
      />
      <Input
        label={<Gettext>Shift</Gettext>}
        name="lips_shift"
        value={props.indicator.lips.shift}
        onChange={props.handleNestedChange("lips", "shift")}
        invalid={props.errors && props.errors.lips_shift}
      />
      <SelectColor
        label={<Gettext>Colour</Gettext>}
        name="lips_color"
        value={props.indicator.lips.color}
        activeSelect={props.activeSelect}
        onClick={props.handleClick}
        onChange={props.handleNestedChange("lips", "color")}
      />
      <SelectWidth
        label={<Gettext>Width of lines</Gettext>}
        name="lips_strokeWidth"
        value={props.indicator.lips.strokeWidth}
        activeSelect={props.activeSelect}
        onClick={props.handleClick}
        onChange={props.handleNestedChange("lips", "strokeWidth")}
      />
    </Row>
  </React.Fragment>
);

export default AlligatorPopup;



// WEBPACK FOOTER //
// ./src/components/Toolbar/AlligatorPopup.js